export default "__VITE_ASSET__CiccvPx7__"